module.exports = __webpack_public_path__ + "img/indicate-web-email@2x.44e9f0a.png";